module.exports = __webpack_public_path__ + "fonts/SourceHanSansCN-Regular.a5632a0a.ttf";